export type CitableFaqItem = {
  q: string;
  a: string;
};

type CitableFaqProps = {
  items: CitableFaqItem[];
  className?: string;
};

export function CitableFaq({ items, className = "" }: CitableFaqProps) {
  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map(({ q, a }) => ({
      "@type": "Question",
      name: q,
      acceptedAnswer: {
        "@type": "Answer",
        text: a,
      },
    })),
  };

  return (
    <div className={className}>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
      />
      <div className="space-y-6">
        {items.map(({ q, a }) => (
          <article
            key={q}
            className="rounded-lg border border-[var(--color-border)] bg-white p-6"
          >
            <h3 className="text-lg font-semibold text-[var(--color-text-primary)]">
              {q}
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-[var(--color-text-secondary)]">
              {a}
            </p>
          </article>
        ))}
      </div>
    </div>
  );
}
